module.exports = __webpack_public_path__ + "img/afterparty-solomun.2b44b661.jpg";